import { useState, useEffect } from 'react';
import { RolesApi } from '@/api/clients/roles/roles.api';

export const useGetRoleHistory = (roleId, options = {}) => {
  const { autoFetch = true } = options;
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    total: 0,
    limit: 50,
  });

  const fetchRoleHistory = async (page = 1, limit = 50) => {
    if (!roleId) {
      setError('Role ID is required');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await RolesApi.getRoleHistory(roleId, { page, limit });

      if (response.data?.data) {
        setHistory(response.data.data || []);
        setPagination(
          response.data.pagination || {
            page: 1,
            limit: 50,
            total: 0,
            totalPages: 1,
          },
        );
      } else {
        throw new Error('Failed to fetch role history');
      }
    } catch (err) {
      console.error('Error fetching role history:', err);
      setError(
        err.response?.data?.error?.message ||
          err.message ||
          'Failed to fetch role history',
      );
      setHistory([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoFetch && roleId) {
      fetchRoleHistory();
    }
  }, [roleId, autoFetch]);

  return {
    history,
    pagination,
    loading,
    error,
    refetch: fetchRoleHistory,
  };
};
